// ======================================================================
// File Name       : AboutRoleDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { MESSAGE_TYPE, MODAL_SIZE } from '../../constants/index';

function AboutRoleDialog({
  showModal,
  onAuthorityAboutOk,
}) {
  const style = {
    background: 'none',
    width: 'auto',
    height: 'auto',
    marginLeft: 0,
    left: 0,
  };

  return (
    <Modal
      className="modal-container"
      show={showModal}
      onHide={onAuthorityAboutOk}
      size={MODAL_SIZE.lg}
      style={style}
      dialogClassName="about-authority-dialog"
    >
      <Modal.Header onHide={onAuthorityAboutOk} closeButton>
        <Modal.Title className="text-center">
          「企業メニューの権限」画面
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped hover>
          <thead>
            <tr>
              <th width={220} />
              <th>全て可能</th>
              <th>参照のみ</th>
              <th>非表示</th>
            </tr>
          </thead>
          <tbody>
            <tr key="1">
              <td>
                企業情報
              </td>
              <td>
                「企業情報」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示、編集、削除、CSV一括投入となります。
              </td>
              <td>
                「企業情報」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示となります。
              </td>
              <td>
                「企業情報」が表示されません。
              </td>
            </tr>
            <tr key="2">
              <td>
                サービス管理
              </td>
              <td>
                「サービス一覧の設定アイコン」、「サービスグループ」、「サービス情報」が表示されます。<br />
                実施可能な機能は、一覧情報の表示、詳細情報の表示、追加、編集、削除、CSV一括追加となります。
              </td>
              <td>
                「サービス一覧の設定アイコン」、「サービスグループ」、「サービス情報」が表示されます。<br />
                実施可能な機能は、一覧情報の表示、詳細情報の表示となります。
              </td>
              <td>
                「サービス一覧の設定アイコン」、「サービスグループ」、「サービス情報」が表示されません。
              </td>
            </tr>
            <tr key="3">
              <td>
                管理ユーザー
              </td>
              <td>
                「管理ユーザー」が表示されます。<br />
                実施可能な機能は、一覧情報の表示、詳細情報の表示、追加、編集、削除、CSV一括追加となります。
              </td>
              <td>
                「管理ユーザー」が表示されます。<br />
                実施可能な機能は、一覧情報の表示、詳細情報の表示となります。
              </td>
              <td>
                「管理ユーザー」が表示されません。
              </td>
            </tr>
            <tr key="4">
              <td>
                ロールと権限
              </td>
              <td>
                「ロールと権限」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示、追加、編集、削除となります。
              </td>
              <td>
                「ロールと権限」が表示されます。<br />
                実施可能な機能は、一覧情報の表示、詳細情報の表示となります。
              </td>
              {/* Step10.0.0 START */}
              <td>
                「ロールと権限」が表示されません。
              </td>
              {/* Step10.0.0 END */}
            </tr>
            <tr key="5">
              <td>
                企業システム利用実績
              </td>
              <td>
                -
              </td>
              <td>
                「企業システム利用実績」が表示されます。<br />
                企業システム利用実績の画面には「企業別」タブまたは「全体」タブが表示されます。
              </td>
              <td>
                「企業システム利用実績」が表示されません。<br />
                ※サービスのシステム利用実績が「表示」になっている場合は表示されます。
              </td>
            </tr>
            <tr key="6">
              <td>
                企業向けお知らせ一覧
              </td>
              <td>
                「企業向けお知らせ一覧」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示、お知らせ情報の新規登録、編集、削除、CSV一括投入となります。
              </td>
              <td>
                「企業向けお知らせ一覧」が表示されます。<br />
                実施可能な機能は一覧情報の表示、詳細情報の表示となります。
              </td>
              <td>
                「企業向けお知らせ一覧」が表示されません。
              </td>
            </tr>
            <tr key="7">
              <td>
                問い合わせ・マニュアル表示
              </td>
              <td>
                「全て表示」が選択されている場合に「問い合わせ」、「マニュアル」が表示されます。<br />
              </td>
              <td>
                「マニュアルのみ」が選択されている場合に「マニュアル」が表示されます。<br />
                「問い合わせ」は表示されません。
              </td>
              <td>
                「非表示」が選択されている場合に「問い合わせ」、「マニュアル」が表示されません。
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer className="text-center">
        <Button variant="primary" className="margin-10 btn-96" onClick={onAuthorityAboutOk}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AboutRoleDialog;
